<div *ngIf="saveOperationState$ | async as saveOperationState" class="save-indicator-container">
  <div
    class="save-indicator"
    [class.visible]="saveOperationState == OperationState.Processing"
    [class.mt-4]="coloredBackground"
    [class.ml-5]="coloredBackground"
  >
    {{ 'Saving' | tekstresource }}
  </div>
  <div
    class="save-indicator"
    [class.visible]="saveOperationState == OperationState.Complete"
    [attr.role]="coloredBackground ? 'alert' : null"
    [class.alert]="coloredBackground"
    [class.alert-success]="coloredBackground"
    [class.mt-0]="coloredBackground"
  >
    {{ 'ChangesSaved' | tekstresource }}
  </div>
  <div
    class="save-indicator"
    [class.visible]="saveOperationState == OperationState.Error"
    [attr.role]="coloredBackground ? 'alert' : null"
    [class.alert]="coloredBackground"
    [class.alert-error]="coloredBackground"
    [class.mt-0]="coloredBackground"
  >
    {{ 'Error' | tekstresource }}
  </div>
</div>
